import { Component, Input, OnInit } from '@angular/core';
import * as Constants from '@emi/shared/constants';

@Component({
    selector: 'via-ui-page-break',
    templateUrl: './page-break.component.html',
    styleUrls: ['./page-break.component.scss'],
})
export class PageBreakComponent implements OnInit {
    @Input()
    public totalSize: number | undefined;

    @Input()
    public pageNumber: number | undefined;

    public pageSize = Constants.Paging.PAGE_SIZE;
    public rangeStart: number;
    public rangeEnd: number;
    public multiplePages: boolean;

    public ngOnInit(): void {
        if (this.totalSize && this.pageNumber) {
            this.multiplePages = this.pageSize < this.totalSize;

            if (this.multiplePages) {
                this.rangeStart = (this.pageNumber - 1) * this.pageSize + 1;
                this.rangeEnd = (this.pageNumber - 1) * this.pageSize + this.pageSize;
            }

            if (this.rangeEnd > this.totalSize) {
                this.rangeEnd = this.totalSize;
            }
        }
    }
}
